import { useContext, useEffect, useRef } from 'react';
import { AuthContext } from '../../contexts/auth'; // Importar AuthContext
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom'; // Importar useLocation para monitorar mudanças de rota
import { checkLicense, verificarLicencaLocal } from '../../services/api';
import { isFeatureEnabled } from '../useFeatureFlag';
import i18n from '../../i18n';

const useCheckLicense = () => {
  const { user, hasLicense, setHasLicense, setRedirectToPlanos } = useContext(AuthContext);
  const location = useLocation(); // Para rastrear mudanças de rota
  const toastShown = useRef(false); // Ref para rastrear se o Toast já foi mostrado
  var pathname = window.location.pathname;

  useEffect(() => {
    const checkLicenseValidity = async () => {
        if (!user) return;

        // Regiões sem Asaas (ex: Líbano) - verificar licença local (data_vencimento_licenca)
        if (!isFeatureEnabled('asaas')) {
          try {
            const response = await verificarLicencaLocal();
            const valid = response.data.hasLicense;

            if (valid) {
              setHasLicense(true);
              setRedirectToPlanos(false);
            } else {
              setHasLicense(false);
              setRedirectToPlanos(true);

              if (!toastShown.current) {
                toast.error(
                  <div>
                    <span dangerouslySetInnerHTML={{ __html: i18n.t('subscription:checkLicense.licenseExpired') }} />
                  </div>,
                  {
                    autoClose: 5000,
                    closeButton: true,
                    draggable: false,
                  }
                );
                toastShown.current = true;
              }
            }
          } catch (error) {
            console.error('[LICENSE] Error checking local license:', error);
            // Fallback: não bloquear em caso de erro de rede
            setHasLicense(true);
            setRedirectToPlanos(false);
          }
          return;
        }

        try {
          const response = await checkLicense(user._id);
          const licenseValid = response.data.hasLicense;
          if(licenseValid){
            setHasLicense(licenseValid);
            setRedirectToPlanos(false);
          }
          if (!licenseValid && !toastShown.current) {
            toast.error(
                <div>
                    <span dangerouslySetInnerHTML={{ __html: i18n.t('subscription:checkLicense.noActiveLicense') }} />
                </div>,
                {
                    autoClose: 5000,
                    closeButton: true,
                    draggable: false,
                }
            );
            toastShown.current = true;
            setHasLicense(false);
            setRedirectToPlanos(true);
          }
        } catch (error) {
          process.env.REACT_APP_ISDEVELOP === 'true' && console.log(error);
        }
    };
    checkLicenseValidity();

  }, [location, user, hasLicense, setHasLicense, setRedirectToPlanos, pathname]); // Reavalie ao mudar de rota
};


export default useCheckLicense;